import React from 'react';

const MapyCzContext = React.createContext({});

export const MapyCzProvider = MapyCzContext.Provider;
export default MapyCzContext;
